import './footer.css'
const Footer = () => {
    return (
        <div className="footer">
            <p>This site created by
                <a href='https://github.com/asaf6024' target='_blank'> @Asaf Almog</a> 2021</p>
        </div>
    )
}
export default Footer